export const addressFormatter = (values, selectedAddress) => ({
  ...values,
  telefono: values.phone,
  entreCalles: values.betweenStreets,
  referencias: values.additionalReferences,
  numeroExterior: values.exteriorNumber,
  numeroInterior: values.interiorNumber,
  ...selectedAddress,
});

export const postAddressFormatter = (values) => ({
  nombre: values.name,
  estado: values.state,
  ciudad: values.city,
  colonia: values.colony,
  calle: values.street,
  codigoPostal: values.postalCode,
  numeroExterior: values.exteriorNumber,
  numeroInterior: values.interiorNumber,
  municipio: values.municipality,
  telefono: values.phone,
  entreCalles: values.betweenStreets,
  referencias: values.additionalReferences,
  accesibilidad: true,
});
